"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedCompletionEnum = exports.EmbeddedSourceEnum = void 0;
var EmbeddedSourceEnum;
(function (EmbeddedSourceEnum) {
    EmbeddedSourceEnum["html"] = "html";
    EmbeddedSourceEnum["link"] = "link";
    EmbeddedSourceEnum["zip"] = "zip";
})(EmbeddedSourceEnum || (exports.EmbeddedSourceEnum = EmbeddedSourceEnum = {}));
var EmbeddedCompletionEnum;
(function (EmbeddedCompletionEnum) {
    EmbeddedCompletionEnum["none"] = "none";
    EmbeddedCompletionEnum["scormPassed"] = "scormPassed";
    EmbeddedCompletionEnum["click"] = "click";
})(EmbeddedCompletionEnum || (exports.EmbeddedCompletionEnum = EmbeddedCompletionEnum = {}));
